import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { HelpLinkButton } from '../modal/helpModal/helpModal';
import { Trash } from '../../icons';

const DCAInstructionsWalmartConnectAdvertising: JSX.Element = (
  <Container
    className="mb-3"
    data-testid="dca-instructions-walmart-connect-advertising"
  >
    <Row>
      <h3
        className="text-capitalize mt-2"
      >
        How to add a Walmart Connect Advertising account to Insights
      </h3>
    </Row>
    <Row>
      <Container>
        <b>
          Notes:
        </b>
        <ul>
          <li>
            Walmart Connect Advertising accounts already in the Insights application cannot be
            added more than once.
          </li>
          <li>
            To add a Walmart Connect Advertising account to Insights, you must have
            admin privileges for the advertiser account in Walmart Connect Ad Center.
          </li>
        </ul>
      </Container>
    </Row>
    <Row className="ps-3 pad-child-list-elements">
      <ol>
        <li>
          <b>
            Sign into Walmart Connect Ad Center:
          </b>
          <ul>
            <li>
              Use a separate browser tab to sign in at&nbsp;
              <a className="ma-link" href="https://advertising.walmart.com/signin">
                https://advertising.walmart.com/signin
              </a>
              .
            </li>
            <li>
              When prompted to choose a media solution, select&nbsp;
              <b>
                Sponsored Search
              </b>
              .
            </li>
            <li>
              Use the top navigation bar to select the correct Walmart advertiser account.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Navigate to the Partners tab:
          </b>
          <ul>
            <li>
              Click on the&nbsp;
              <b>
                Account
              </b>
              &nbsp;dropdown in the upper right corner and select&nbsp;
              <b>
                Manage profile and account
              </b>
              .
            </li>
            <li>
              Click on the&nbsp;
              <b>
                Partners
              </b>
              &nbsp;tab.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Add Marshall Insights as a partner:
          </b>
          <ul>
            <li>
              Click the&nbsp;
              <b>
                + Add Partner
              </b>
              &nbsp;button.
            </li>
            <li>
              Enter&nbsp;
              <b>
                Marshall Insights
              </b>
              &nbsp;in the search field and select it.
            </li>
            <li>
              Follow the instructions to add Marshall Insights as a partner. Note that
              Marshall Insights only requires&nbsp;
              <b>
                Read Only
              </b>
              &nbsp;access.
            </li>
            <li>
              If Marshall Insights is already listed as a partner, you can skip this step.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Get the Advertiser ID:
          </b>
          <ul>
            <li>
              Still in the&nbsp;
              <b>
                Manage profile and account
              </b>
              &nbsp;section from step 2, click on&nbsp;
              <b>
                Ad accounts
              </b>
              &nbsp;in the left sidebar.
            </li>
            <li>
              Locate the advertising account and copy the&nbsp;
              <b>
                Advertiser ID
              </b>
              &nbsp;listed below the account name to your clipboard.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Paste in the Advertiser ID below:
          </b>
          <ul>
            <li>
              Place it in the&nbsp;
              <b>
                Advertiser ID
              </b>
              &nbsp;field below these instructions.  This value should be a number.
            </li>
            <li>
              Click the&nbsp;
              <span className="badge bg-black">
                Add
              </span>
              &nbsp;button below.
            </li>
          </ul>
        </li>
        <li>
          <b>
            Review the authorized Walmart Connect Advertising accounts:
          </b>
          <ul>
            <li>
              Check that all authorized accounts appear in this interface.
            </li>
            <li>
              To remove any account, click the trash icon (
              <Trash fill="var(--blushing-salmon)" />
              ) next to it.
            </li>
            <li>
              If any accounts are missing, repeat the above steps to add them.
            </li>
          </ul>
        </li>
      </ol>
    </Row>
    <Row>
      <b>
        Troubleshooting:
      </b>
      <p>
        If you encounter any issues or have questions, contact
        <HelpLinkButton />
        .
      </p>
    </Row>
  </Container>
);

export default DCAInstructionsWalmartConnectAdvertising;
